

































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ILanguage } from "@/models/constants";
import {
  INotificationCategory,
  INotificationTemplate,
  INotificationTemplateContent
} from "@/models/notifications";
import RequestPromises from "@/mixins/requestPromises";
import { mapState } from "vuex";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";

@Component({
  computed: {
    ...mapState({
      languages: (state: IState) => state.brand.languages
    })
  }
})
export default class NotificationTemplatesContentsTable extends Mixins(
  RequestPromises
) {
  @Prop({ required: true })
  public template!: INotificationTemplate;
  @Prop({ required: true })
  public categories!: INotificationCategory[];
  public languages!: ILanguage[];

  public hasLanguage(language: ILanguage) {
    return (
      this.$_.findIndex(this.template.contents, [
        "language_id",
        language.id
      ]) !== -1
    );
  }

  public openNotificationFormModal(languageId: ILanguage["id"]) {
    const content = this.$_.find(this.template.contents, [
      "language_id",
      languageId
    ]);

    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import(
            "@/components/app/admin/notifications/templates/translationContentsForm.vue"
          ),
        props: {
          languageId,
          languages: this.languages,
          categories: this.categories,
          contentId: this.$_.get(content, "id", ""),
          template: this.template
        },
        events: {
          "content-updated": () => this.$emit("contents-updated")
        }
      }
    });
  }

  public getLanguageLabel(language: ILanguage) {
    const hasLanguage = this.hasLanguage(language);

    if (hasLanguage && !this.$userCan("update_notification_template_content")) {
      return this.$t("_action.view");
    }

    if (hasLanguage && this.$userCan("update_notification_template_content")) {
      return this.$t("_action.manage");
    }

    if (!hasLanguage && this.$userCan("create_notification_template_content")) {
      return this.$t("_action.translate");
    }

    return "";
  }

  public async deleteContent(languageId: ILanguage["id"]) {
    const content = this.$_.find(this.template.contents, [
      "language_id",
      languageId
    ]) as INotificationTemplateContent;
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.translation") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            try {
              await this.deleteConfirmed(content);
              this.$emit("contents-updated");
              this.$buefy.toast.open({
                message: this.$t("_.translation_deleted") as string
              });
              confirm.close();
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            }
          }
        }
      }
    });
  }

  public deleteConfirmed(content: INotificationTemplateContent) {
    return this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_TEMPLATES_CONTENTS}/remove`,
      {
        id: content.id,
        templateId: content.template_id
      }
    );
  }
}
